import { render } from "./PopupDeleteModal.vue?vue&type=template&id=2fafc52c&scoped=true"
import script from "./PopupDeleteModal.vue?vue&type=script&lang=js"
export * from "./PopupDeleteModal.vue?vue&type=script&lang=js"

import "./PopupDeleteModal.vue?vue&type=style&index=0&id=2fafc52c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fafc52c"]])

export default __exports__